import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import { accessNested } from 'utils/utils';
import { idle } from 'utils/redirect';
// import s from 'base/bolt/boltApp.sss';

export default class BoltApp extends BaseComp.default {
	componentDidMount() {
		super.componentDidMount();
		const idleRedirect = accessNested(this.state.appState, 'appData.options.idleRedirect', {});
		if (idleRedirect.enable) {
			idle(idleRedirect.timeOut,idleRedirect.redirectUrl);
		}
	}
	handleResize() {
		super.handleResize();
		document.documentElement.style.setProperty('--vh-unitless', (window.innerHeight * 0.01));
		document.documentElement.style.setProperty('--vw-unitless', (window.innerWidth * 0.01));
	}
}
